import React from 'react';

import '../stylings/NewsElement.css';


export default function NewsElement(props) {
	return (
		<li>
			<div className="news-element">
				<div className="news-element__image" style={{backgroundImage: `url(${props.imageSrc})`}}></div>
				<h3>{props.title}</h3>
				<h4>Von <strong>{props.author}</strong> am {props.date}</h4>
				<div className="news-element__content">
					<p> {props.newsContent} </p>
				</div>
			</div>
		</li>
	);
}


// WEBPACK FOOTER //
// ./src/components/News/NewsElement.js